var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { isItemAllowed, SwapFormKey, useLiFi, useWidgetConfig, } from '../providers';
import { useChainOrderStore } from '../stores';
export const useChains = () => {
    const { disabledChains, chains } = useWidgetConfig();
    const lifi = useLiFi();
    const { getValues, setValue } = useFormContext();
    const { data, isLoading } = useQuery(['chains'], () => __awaiter(void 0, void 0, void 0, function* () {
        const availableChains = yield lifi.getChains();
        const filteredChains = availableChains.filter((chain) => isItemAllowed(chain.id, chains, disabledChains));
        const chainOrder = useChainOrderStore
            .getState()
            .initializeChains(filteredChains.map((chain) => chain.id));
        const [fromChainValue, toChainValue] = getValues([
            SwapFormKey.FromChain,
            SwapFormKey.ToChain,
        ]);
        if (!fromChainValue) {
            setValue(SwapFormKey.FromChain, chainOrder[0]);
        }
        if (!toChainValue) {
            setValue(SwapFormKey.ToChain, chainOrder[0]);
        }
        return { availableChains, filteredChains };
    }));
    const getChainById = useCallback((chainId) => {
        const chain = data === null || data === void 0 ? void 0 : data.availableChains.find((chain) => chain.id === chainId);
        // if (!chain) {
        //   throw new Error('Chain not found or chainId is invalid.');
        // }
        return chain;
    }, [data]);
    return { chains: data === null || data === void 0 ? void 0 : data.filteredChains, getChainById, isLoading };
};
